export const reCaptchaStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  error: {
    color: 'error.main',
    typography: 'textSm',
  },
}
